import { FolderNode } from 'types/sequences';
import _isEmpty from 'lodash-es/isEmpty';

export function getLinkOfFolderNode(
  item: FolderNode,
  ancestors: FolderNode[],
): string {
  switch (item.type) {
    case 'fdp': {
      if (ancestors.length === 0) {
        // safe fallback
        return '/sequences';
      }
      const parentSequenceId = ancestors[ancestors.length - 1].id;
      return `/sequences/${parentSequenceId}/fiches-de-prep/${item.id}`;
    }
    case 'fdp_standalone':
      return `/fiches-de-prep/${item.id}`;
    case 'sequence':
      return `/sequences/${item.id}`;
    case 'folder':
      return `/sequences/folders/${item.id}`;
  }
}

export const sequenceUrls = {
  all: '/sequences',
  sequenceDetails: (id: string) => `${sequenceUrls.all}/${id}`,
  new: (folderId?: string) => {
    const newSequenceUrl = `${sequenceUrls.all}/new`;
    if (_isEmpty(folderId)) {
      return newSequenceUrl;
    }
    return `${newSequenceUrl}?folderId=${folderId}`;
  },
  preview: (sequenceId: string) =>
    `${sequenceUrls.sequenceDetails(sequenceId)}/preview`,
  fdpDetails: (sequenceId: string, fdpId: string) =>
    `${sequenceUrls.sequenceDetails(sequenceId)}/fiches-de-prep/${fdpId}`,
  fdpPreview: (sequenceId: string, fdpId: string) =>
    `${sequenceUrls.fdpDetails(sequenceId, fdpId)}/preview`,
};
